import { render, staticRenderFns } from "./PalataByDoctor.vue?vue&type=template&id=09e6a207&scoped=true"
import script from "./PalataByDoctor.vue?vue&type=script&lang=js"
export * from "./PalataByDoctor.vue?vue&type=script&lang=js"
import style0 from "./PalataByDoctor.vue?vue&type=style&index=0&id=09e6a207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e6a207",
  null
  
)

export default component.exports